import axios from "axios";

const api = axios.create({
  baseURL: "http://localhost:8113/api", // Updated backend API base URL
});

export default api;
